import React from 'react';
import { useOutletContext } from 'react-router-dom';
import useSeo from '../seo';

const Pricing = () => {
  const { openAudit } = useOutletContext(); // Grab modal trigger

  useSeo('/pricing');

  return (
    <section className="mn-section" id="pricing">
      <div className="mn-container">
        <div className="mn-section-head">
          <span className="mn-kicker">Transparent Value</span>
          <h1>Pay for complexity, not per user.</h1>
          <p>
            We don't believe in the traditional "per-user" pricing model. Charging per seat restricts adoption and creates operational silos within your business. Instead, you pay for the modules and sites you activate. This modular approach makes Mantle affordable for small businesses while remaining comprehensive for large organizations — without ever restricting who can use the platform or when they can use it.
          </p>
        </div>
        <div className="mn-grid-3">
          <div className="mn-card">
            <div className="mn-card-icon">🏢</div>
            <h3>1. The Site Foundation</h3>
            <p>Every active physical location (Factory, Warehouse, Depot, Project Site) requires a base license. This covers platform access, user management, security, OPEX, and site reporting.</p>
          </div>
          <div className="mn-card">
            <div className="mn-card-icon">🧩</div>
            <h3>2. Add-On Modules</h3>
            <p>Activate complexity only where you need it. Add specific modules like Manufacturing, Distribution, CAPEX, or People & Paycost on a per-site basis depending on the site's function.</p>
          </div>
          <div className="mn-card">
            <div className="mn-card-icon">🌐</div>
            <h3>3. The Aggregation Layer</h3>
            <p>A country node fee covers the Head Office view, consolidating all sites into a single currency and P&L with inter-company eliminations and consolidated C-suite dashboards.</p>
          </div>
        </div>
        <div className="mn-cta-band" style={{ marginTop: '40px' }}>
          <button type="button" className="mn-btn mn-btn-primary mn-btn-lg" onClick={openAudit}>
            Request a Meeting for Custom Pricing
          </button>
        </div>
      </div>
    </section>
  );
};

export default Pricing;